import React, { useEffect } from "react";
import Sidebar from "../../components/sidebar";
import Header from "../../components/header";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/authFetch";

function CounterRegistration() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);
  const [problemQuery, setProblemQuery] = useState("");
  const [ProblemList, setProblemList] = useState([]);
  const [doctorQuery, setDoctorQuery] = useState("");
  const [doctorList, setDoctorList] = useState([]);
  const [amount, setAmount] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const [appointmentDate, setAppointmentDate] = useState(today);
  const [totalAppointments, setTotalAppointments] = useState(0);

  useEffect(() => {
    if (!problemQuery) {
      setProblemList([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      authFetch(`${API_BASE_URL}/api/problem-options?query=${problemQuery}`)
        .then((res) => res.json())
        .then((data) => {
          setProblemList(data.problems.map((d) => d.name));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [problemQuery]);

  useEffect(() => {
    if (
      !appointmentDate ||
      !doctorList ||
      !doctorQuery ||
      !doctorList.includes(doctorQuery)
    ) {
      return;
    }

    const fetchPatient = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/get-total-appointment?date=${appointmentDate}&doctor=${doctorQuery}`
        );
        const result = await response.json();
        setTotalAppointments(result.total_appointments);
      } catch (error) {
        console.error("Error fetching patient:", error);
      }
    };

    fetchPatient();
  }, [doctorQuery, appointmentDate]);

  useEffect(() => {
    if (!doctorQuery) {
      setProblemList([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      authFetch(`${API_BASE_URL}/api/doctor-options?query=${doctorQuery}`)
        .then((res) => res.json())
        .then((data) => {
          setDoctorList(data.doctors.map((d) => d.name));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [doctorQuery]);

  useEffect(() => {
    if (!doctorQuery || !doctorList.includes(doctorQuery)) {
      setAmount("");
      return;
    }

    const fetchAmount = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/fees?doctor=${doctorQuery}`
        );
        const result = await response.json();
        setAmount(Number(result.fees));
      } catch (error) {
        console.error("Error fetching amount:", error);
      }
    };

    fetchAmount();
  }, [doctorQuery, doctorList]);

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);
    const url = `${API_BASE_URL}/api/registration`;

    formData.append("type", "reg");

    const method = "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("Patient Registered successfully");
        formRef.current.reset();
        setIsSubmitting(false);
        setLoader(false);
        setProblemQuery("");
        setProblemList([]);
        setDoctorList([]);
        setDoctorQuery("");
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5 className="mb-3">Counter Registration</h5>
            <Form onSubmit={handleSubmit} ref={formRef}>
              <Row className="align-items-end g-3">
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formDoctor">
                    <Form.Label>
                      Doctor <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Select Doctor"
                      name="doctor"
                      required
                      autoComplete="off"
                      list="doctor-options"
                      value={doctorQuery}
                      onChange={(e) => setDoctorQuery(e.target.value)}
                    />
                    <datalist id="doctor-options">
                      {doctorList.map((option, index) => (
                        <option key={index} value={option} />
                      ))}
                    </datalist>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formAmount">
                    <Form.Label>Appointment Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="appointmentDate"
                      value={appointmentDate}
                      onChange={(e) => setAppointmentDate(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group
                    className="mb-3"
                    controlId="formTotalAppointments"
                  >
                    <Form.Label>Total Appointments</Form.Label>
                    <Form.Control
                      type="text"
                      name="totalAppointments"
                      value={totalAppointments}
                      readOnly
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formPatientName">
                    <Form.Label>
                      Patient Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Patient Name"
                      name="name"
                      required
                      autoComplete="off"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formGender">
                    <Form.Label>
                      Gender <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select aria-label="Category" name="gender" required>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formAge">
                    <Form.Label>
                      Age <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter Age"
                      name="age"
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formContactNumber">
                    <Form.Label>
                      Contact Number <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="tel"
                      placeholder="Enter Contact Number"
                      name="contactNumber"
                      required
                      pattern="[0-9]{10}"
                      autoComplete="off"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formAddress">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter address"
                      name="address"
                      autoComplete="off"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter Email"
                      name="email"
                      autoComplete="off"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formAmount">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Choose Doctor"
                      name="fees"
                      value={amount}
                      onChange={(e) => setAmount(Number(e.target.value))}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formProblem">
                    <Form.Label>
                      Problem <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Select Problem"
                      name="problem"
                      required
                      autoComplete="off"
                      list="problem-options"
                      value={problemQuery}
                      onChange={(e) => setProblemQuery(e.target.value)}
                    />
                    <datalist id="problem-options">
                      {ProblemList.map((option, index) => (
                        <option key={index} value={option} />
                      ))}
                    </datalist>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formReferredBy">
                    <Form.Label>Referred By</Form.Label>
                    <Form.Select aria-label="Category" name="referredBy">
                      <option value="Doctor">Doctor</option>
                      <option value="Friend/Family">Friend/Family</option>
                      <option value="Old Patient">Old Patient</option>
                      <option value="Social Media">Social Media</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formPaymentMode">
                    <Form.Label>Payment Mode</Form.Label>
                    <Form.Select
                      aria-label="Category"
                      name="paymentMode"
                      required
                    >
                      <option value="Cash">Cash</option>
                      <option value="Card">Card</option>
                      <option value="UPI">UPI</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Button variant="primary" type="submit" disabled={isSubmitting}>
                SUBMIT
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CounterRegistration;
